import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import {
  ComparativeDisplayType,
  FilterPatchBody,
  KpiOptionObject,
  RollingType,
  UnitPrefix
} from 'types/GlobalKpiOption'
import { ShowPerEnum } from 'types/GlobalMetric'

export type TPostKpiOptionBody = {
  widget_id: string
  title: string
  kpi_template_id: string
  variant_kpi_template_id: string | null
  rolling_sum: RollingType | null
  distribution: ShowPerEnum | null
  slices: string[]
}

export type TPatchKpiOptionBody = {
  auto_format?: boolean
  breakdown_by?: string | null
  comparative_display_type?: ComparativeDisplayType | null
  equivalent?: {
    factor: number | null
    unit: string | null
  }
  filters?: FilterPatchBody[]
  share_filters?: FilterPatchBody[]
  show_per_filters?: FilterPatchBody[]
  hidden?: boolean
  increase_is_positive?: boolean
  is_share_kpi?: boolean
  lower_bound_threshold?: number | null
  number_of_decimals?: number
  show_comparative?: boolean
  title?: string
  unit_prefix?: UnitPrefix | null
  upper_bound_threshold?: number | null
  rolling_sum?: RollingType | null
  distribution?: ShowPerEnum | null
  slices?: string[]
}

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/kpi-options`

export async function create(data: TPostKpiOptionBody) {
  return axios.post<{ data: KpiOptionObject }>(
    URL,
    { data },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, data: TPatchKpiOptionBody) {
  return axios.patch<{ data: KpiOptionObject[] }>(
    `${URL}/${id}`,
    { data },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export function skipFetchDataOnUpdate(body: TPatchKpiOptionBody) {
  return (
    'increase_is_positive' in body ||
    'upper_bound_threshold' in body ||
    'lower_bound_threshold' in body ||
    'number_of_decimals' in body ||
    'unit_prefix' in body ||
    'equivalent' in body ||
    'hidden' in body
  )
}
